import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { IApplicationState } from '@store'
import { selectInfluencerIdentitiesSortByOptions } from '@store/campaigns'
import { selectCampaignId } from '@store/router'
import { ISubmissionSortProps } from './Sort'
import SubmissionSortWrapper from './SortWrapper'

const SortInfluencerIdentityList = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const sortOptions = useSelector((state: IApplicationState) =>
    selectInfluencerIdentitiesSortByOptions(state, campaignId),
  )

  const props: ISubmissionSortProps = { campaignId, sortOptions }
  return <SubmissionSortWrapper {...props} />
}

export default SortInfluencerIdentityList
